/**
 * Alcedis select widget extension
 *
 * @copyright   Alcedis GmbH
 * @version     SVN:$
 */
$.fn.afFormWidgetSelect = $.fn.afFormWidgetSelect || function() {
    "use strict";

    // iterate over each select widget element which plugin is called on
    this.each(function() {

        /**
         * jQuery select element
         *
         * @type {JQuery|jQuery|HTMLElement}
         */
        var $select = $(this);


        /**
         * true if select element has multiple select option
         *
         * @type {boolean|*}
         */
        var isMultipleSelect = $select.is("[multiple]");


        // bind data conversion to this select element if is multiple select
        if (isMultipleSelect === true) {
            // assigned fieldValue (getter) only once
            if ($select.data("$.fieldValue") === undefined) {
                // bind own fieldValue method for post request
                $select.data("$.fieldValue", function ($el) {
                    var val = $el.val();
                    var fieldValue = "";
                    var separator;

                    // only check if val is filled (array or string)
                    if (val !== null && val.length > 0) {
                        // remove empty array values
                        val = val.filter(function (n) {
                            return n !== undefined && n.length > 0;
                        });

                        separator = $el.data("multiple-data-separator");
                        fieldValue = separator + val.join(separator) + separator;
                    }

                    return fieldValue;
                });
            }

            // assigned fieldValue (setter) only once // currently used by audittrail value set
            if ($select.data("$.setFieldValue") === undefined) {
                // bind own fieldValue method for post request
                $select.data("$.setFieldValue", function ($el, value) {
                    var separator;
                    var values;

                    // check if value could be parsed
                    if (value !== undefined && value.length > 0) {
                        separator = $el.data("multiple-data-separator");
                        values = value.split(separator);

                        // remove outer separator elements
                        values.shift();
                        values.pop();

                        // use jquery setter
                        $el.val(values);
                    }
                });
            }
        }
    });
};
